'use strict'

var assign = Object.assign

module.exports = assign
